export default __webpack_public_path__ + "static/media/poster_2022.13447574.svg";